import React from 'react';
import PropTypes from 'prop-types';
import dateformat from 'dateformat';
import HoverReveal from './AdminDashboardHoverReveal';

const formatDate = (date, dateFormat = 'yyyy-mm-dd h:MMtt') => dateformat(date, dateFormat);

const AdminDashboardTimestamp = ({ timestamp, dateFormat, showRawTimestamp = true }) => {
    if (!timestamp) return <span>-</span>;

    const formattedDate = formatDate(timestamp, dateFormat);

    if (!showRawTimestamp) return <span className="Timestamp">{formattedDate}</span>;

    return (
        <HoverReveal className="Timestamp" revealChildren={timestamp}>
            {formattedDate}
        </HoverReveal>
    );
};

AdminDashboardTimestamp.propTypes = {
    timestamp: PropTypes.number,
    dateFormat: PropTypes.string,
    showRawTimestamp: PropTypes.bool,
};

export default AdminDashboardTimestamp;
